import fidusLogo from "./Assets/FidusLogo.png";

const Footer = () => {
  return (
    <>
      <footer>
        <div className="bg">
          <div className="row">
            <div className="col-lg-5">
              <div className="left">
                {/* <span>About the company</span> */}

                {/* <img
                src={fidusLogo}
                width={75}
                // className="logo d-inline-block align-top"
                alt="Fidus India"
              /> */}
                <h4>Fidus Business Services Pvt. Ltd.</h4>

                <p className="text-white">At Fidus, we specialize in creating innovative, high-quality e-learning solutions tailored to meet the specific needs of a wide range of industries.
                  While our expertise spans across multiple sectors, we have a particular focus on the Aviation industry, where we deliver cutting edge training solutions that ensure safety, compliance, and operational efficiency.</p>

              </div>
            </div>
            <div className="col-lg-3">
              <div className="center">
                {/* <img src={FooterGirl} alt="" /> */}
              </div>
            </div>
            <div className="col-lg-4">
              <div className="right">
                {/* <h4>GET IN TOUCH</h4> */}
                <div className="d-flex flex-column gap-4">
                  <p className="d-flex gap-2">
                    <span><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#ffffff" className="bi bi-envelope-fill" viewBox="0 0 16 16">
                      <path d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414zM0 4.697v7.104l5.803-3.558zM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586zm3.436-.586L16 11.801V4.697z" />
                    </svg></span>
                    <span className="text-white">enquiry@fidusindia.in</span>
                  </p>
                  <p className="d-flex gap-2">
                    <span><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#ffffff" className="bi bi-telephone-fill" viewBox="0 0 16 16">
                      <path fillRule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z" />
                    </svg></span>
                    <span className="text-white">+91 2048465792</span>
                  </p>
                  <p className="d-flex gap-2">
                    <span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#ffffff" className="bi bi-geo-alt-fill" viewBox="0 0 16 16">
                        <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10m0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6" />
                      </svg>
                    </span>
                    <span className="text-white">
                      Unit No. 507, Lunkad Sky Vista, <br /> Lohegaon, Viman nagar
                      Pune <br />
                      411014.
                    </span>

                  </p>
                  <div className="social">
                    <a href="https://www.facebook.com/share/1NxdJiVH1C/" target="__blank" aria-label="Visit Facebook Page">
                      <svg width="30" height="30" viewBox="0 0 51 51" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clipPath="url(#clip0_1736_7698)">
                          <path d="M28.6465 11.1738C28.6465 9.16211 30.4434 8.43945 32.4551 8.43945C34.4668 8.43945 36.6152 9.06445 36.6152 9.06445L37.9043 1.4082C37.9043 1.4082 35.1699 0.470703 28.6465 0.470703C24.6426 0.470703 22.3184 1.99414 20.6191 4.24023C19.0176 6.36914 18.959 9.78711 18.959 11.9941V17.0137H13.7832V24.4941H18.959V50.4707H28.6465V24.4941H36.3223L36.8887 17.0137H28.6465V11.1738Z" fill="white" />
                        </g>
                        <defs>
                          <clipPath id="clip0_1736_7698">
                            <rect width="50" height="50" fill="white" transform="translate(0.84375 0.470703)" />
                          </clipPath>
                        </defs>
                      </svg>

                    </a>
                    <a href="https://x.com/fidus_india" target="__blank" aria-label="Visit Twitter/X Page">
                      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="#ffffff" className="bi bi-twitter-x" viewBox="0 0 16 16">
                        <path d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z" />
                      </svg>
                    </a>
                    <a
                      href="https://www.instagram.com/fidus_india/?igsh=ZW1lYmxkeHI0YXpi#"
                      target="__blank"
                      aria-label="Visit Instagram Page"
                    >
                      <svg width="40" height="40" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M43.1628 19.2701H43.1883M21.1774 51.8034H41.5108C47.1255 51.8034 51.6774 47.2515 51.6774 41.6367V21.3034C51.6774 15.6885 47.1255 11.1367 41.5108 11.1367H21.1774C15.5625 11.1367 11.0107 15.6885 11.0107 21.3034V41.6367C11.0107 47.2515 15.5625 51.8034 21.1774 51.8034ZM40.8753 31.4701C40.8753 36.7341 36.6081 41.0013 31.3441 41.0013C26.0801 41.0013 21.8128 36.7341 21.8128 31.4701C21.8128 26.2061 26.0801 21.9388 31.3441 21.9388C36.6081 21.9388 40.8753 26.2061 40.8753 31.4701Z" stroke="white" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </a>
                    <a
                      href="https://www.linkedin.com/company/fidus-business-services/"
                      target="__blank"
                      aria-label="Visit LinkedIn Page"
                    >
                      <svg width="30" height="30" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clipPath="url(#clip0_1736_7707)">
                          <path fillRule="evenodd" clipRule="evenodd" d="M45.8438 45.9707H36.8438V30.2229C36.8438 25.9029 34.938 23.4927 31.5203 23.4927C27.801 23.4927 25.5938 26.0042 25.5938 30.2229V45.9707H16.5938V16.7207H25.5938V20.01C25.5938 20.01 28.4175 15.0552 34.7805 15.0552C41.1457 15.0552 45.8438 18.9394 45.8438 26.9764V45.9707ZM6.33825 12.0427C3.303 12.0427 0.84375 9.56336 0.84375 6.50562C0.84375 3.45012 3.303 0.970703 6.33825 0.970703C9.37125 0.970703 11.8305 3.45012 11.8305 6.50562C11.8327 9.56336 9.37125 12.0427 6.33825 12.0427ZM0.84375 45.9707H12.0938V16.7207H0.84375V45.9707Z" fill="white" />
                        </g>
                        <defs>
                          <clipPath id="clip0_1736_7707">
                            <rect width="45" height="45" fill="white" transform="translate(0.84375 0.970703)" />
                          </clipPath>
                        </defs>
                      </svg>

                    </a>
                  </div>
                </div>



              </div>
            </div>
            <div className="col-lg-12">
              <div className="copyright">
                <span>© 2025 Fidus, All Rights Reserved</span>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
